<!--
 * @Author: your name
 * @Date: 2022-03-04 16:55:46
 * @LastEditTime: 2022-03-09 11:29:47
 * @LastEditors: Please set LastEditors
 * @Description: 实名认证 认证通过页面
 * @FilePath: \code\wx-front\src\views\contract\certificationPassed.vue
-->
<template>
<div class="wrap colAc fontH3">
    <img src="../../assets/static/contract/certificationPassed.svg" class="topImg" alt="">
    <div class="fontScN7 fontH1 passText medium">认证通过</div>
    <div class="fontScN6">恭喜您，您的实名认证已经通过！</div>
    <div class="fontScN6">已为您申请了数字证书，现在即可签署合同。</div>
    <div class="ensureBtn rowJcAc fontScW bgcMcA1" @click="clickEnsure">确定</div>
    
</div>
</template>

<script>
export default {
  data() {
    return {
       

    };
  },
   computed: {
    },
    watch: {
    },
  created() {
  },
  mounted() {
  },
  methods: {
    //点击确定
    clickEnsure(){
      this.$router.go(-3)
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap {  
background: #fff;
height: 100%;
font-size: 14px;
padding: 1.2rem 0.24rem 0 0.24rem;
box-sizing: border-box;
}

.topImg{
    width: 1.18rem;
    height: 1.18rem;
}
.ensureBtn{
    width: 100%;
    height: 44px;
    border-radius: 6px;
    margin-top: 40px;
}
.passText{
  margin: 8px 0;
}
</style>
